import { render, staticRenderFns } from "./SaleBonusList.vue?vue&type=template&id=474ebf6f&scoped=true&"
import script from "./SaleBonusList.vue?vue&type=script&lang=js&"
export * from "./SaleBonusList.vue?vue&type=script&lang=js&"
import style0 from "./SaleBonusList.vue?vue&type=style&index=0&id=474ebf6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474ebf6f",
  null
  
)

component.options.__file = "SaleBonusList.vue"
export default component.exports